import low from 'lowdb';
import LocalStorage from 'lowdb/adapters/LocalStorage';
import Setting from '@/setting';
var adapter = new LocalStorage("admin-plus-".concat(Setting.appID));
var db = low(adapter);
db.defaults({
  sys: {},
  database: {}
}).write();
export default db;